exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-65732e5c] .el-dialog__title {\n  font-size: 25px;\n  color: #606266;\n}\n[data-v-65732e5c] .el-form-item__label {\n  font-family: Arial, Helvetica, sans-serif;\n}\n[data-v-65732e5c] .el-dialog__body {\n  padding-bottom: 5px;\n}\n.input-common[data-v-65732e5c] {\n  margin-right: 5px;\n}\n", ""]);

// exports
